import { RootState } from '../../main/store/main.store.ts';

import { Account } from '../slices/accounts/accounts.slice.types.ts';

export const selectAccount = (state: RootState): Account | undefined => state.accounts.currentAccount;
